import React from 'react';
import { WebsiteLayout } from '../components/common/layout';
import { Privacy } from '../components/screens';

function PageWithLayout(props) {
  const { logout, user } = props;

  return (
    <WebsiteLayout navbarBackgroundColor="white" user={user} handleLogout={logout}>
      <Privacy />
    </WebsiteLayout>
  );
}

export default PageWithLayout;
